import React from 'react';

export const SvgCommunity = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="25"
      height="17"
      viewBox="0 0 25 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M4.1 7.29961C5.42375 7.29961 6.5 6.22336 6.5 4.89961C6.5 3.57586 5.42375 2.49961 4.1 2.49961C2.77625 2.49961 1.7 3.57586 1.7 4.89961C1.7 6.22336 2.77625 7.29961 4.1 7.29961ZM20.9 7.29961C22.2238 7.29961 23.3 6.22336 23.3 4.89961C23.3 3.57586 22.2238 2.49961 20.9 2.49961C19.5763 2.49961 18.5 3.57586 18.5 4.89961C18.5 6.22336 19.5763 7.29961 20.9 7.29961ZM22.1 8.49961H19.7C19.04 8.49961 18.4438 8.76586 18.0087 9.19711C19.52 10.0259 20.5925 11.5221 20.825 13.2996H23.3C23.9637 13.2996 24.5 12.7634 24.5 12.0996V10.8996C24.5 9.57586 23.4237 8.49961 22.1 8.49961ZM12.5 8.49961C14.8212 8.49961 16.7 6.62086 16.7 4.29961C16.7 1.97836 14.8212 0.0996094 12.5 0.0996094C10.1788 0.0996094 8.3 1.97836 8.3 4.29961C8.3 6.62086 10.1788 8.49961 12.5 8.49961ZM15.38 9.69961H15.0688C14.2888 10.0746 13.4225 10.2996 12.5 10.2996C11.5775 10.2996 10.715 10.0746 9.93125 9.69961H9.62C7.235 9.69961 5.3 11.6346 5.3 14.0196V15.0996C5.3 16.0934 6.10625 16.8996 7.1 16.8996H17.9C18.8938 16.8996 19.7 16.0934 19.7 15.0996V14.0196C19.7 11.6346 17.765 9.69961 15.38 9.69961ZM6.99125 9.19711C6.55625 8.76586 5.96 8.49961 5.3 8.49961H2.9C1.57625 8.49961 0.5 9.57586 0.5 10.8996V12.0996C0.5 12.7634 1.03625 13.2996 1.7 13.2996H4.17125C4.4075 11.5221 5.48 10.0259 6.99125 9.19711Z"
        fill="currentColor"
      />
    </svg>
  );
};
